export default __webpack_public_path__ + "static/image-todo-app-ab96ff8e352ad643f5d0205b6081eb67.png";